import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-esic',
  templateUrl: './esic.component.html',
  styleUrls: ['./esic.component.scss']
})
export class EsicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
